module.exports = __webpack_public_path__ + "static/05-EGIPTO.e1af2619.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/players/05-EGIPTO.png
// module id = 696
// module chunks = 35783957827783